import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';

function EventCard({ event }) {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const imageUrl = event.image || null;

  return (
    <div style={{ cursor: 'pointer', marginBottom: isMobile ? '1.5rem' : '0' }} onClick={() => navigate(`/${event.slug || event.id}`)}>
      <div style={{ width: '100%', aspectRatio: '2/3', overflow: 'hidden', borderRadius: '8px', marginBottom: '0.8rem' }}>
        {imageUrl ? (
          <img src={imageUrl} alt={event.name} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', transition: 'transform 0.3s ease' }}
            onMouseOver={e => !isMobile && (e.target.style.transform = 'scale(1.05)')}
            onMouseOut={e => !isMobile && (e.target.style.transform = 'scale(1)')}
          />
        ) : (
          <div style={{ width: '100%', height: '100%', backgroundColor: colors.bgTertiary, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem' }}>🎵</div>
        )}
      </div>
      <div>
        <p style={{ color: colors.accent, fontSize: '0.72rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.3rem' }}>
          {event.category || 'Evento'} · {event.location}
        </p>
        <h3 style={{ color: colors.text, fontSize: isMobile ? '1.1rem' : '1.05rem', fontWeight: 'bold', marginBottom: '0.3rem' }}>{event.name}</h3>
        <p style={{ color: colors.textSecondary, fontSize: '0.82rem', marginBottom: event.description ? '0.3rem' : '0' }}>
          {new Date(event.date).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })} · Desde {event.price}€
        </p>
        {event.description && (
          <p style={{ color: colors.textSecondary, fontSize: '0.78rem', lineHeight: 1.5, margin: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
            {event.description}
          </p>
        )}
      </div>
    </div>
  );
}

export default EventCard;